import { useMemo } from 'react';
import { useProjectChromeBranding } from './ProjectChromeBrandingContext';
import { getSiteTitle } from '../utils/appBranding';

const DEFAULT_TITLE = getSiteTitle();

/**
 * Derived navigation for org-branded project chrome.
 * Single source for hub home targets and back-link labels.
 */
export function useOrgWorkspaceNav() {
    const { resolvedBranding } = useProjectChromeBranding();

    return useMemo(() => {
        const organizationName = (resolvedBranding?.organizationName || '').trim();
        const brandTitle = (resolvedBranding?.title || '').trim();
        const logoItemId = resolvedBranding?.logoItemId
            ? String(resolvedBranding.logoItemId).trim() || null
            : null;
        const isOrgWorkspace = !!organizationName;
        const orgHomeTo = isOrgWorkspace
            ? `/projects/org/${encodeURIComponent(organizationName)}`
            : null;
        const orgBackLabel = isOrgWorkspace
            ? `← ${brandTitle || organizationName}`
            : null;

        return {
            isOrgWorkspace,
            organizationName: organizationName || null,
            brandTitle: brandTitle || null,
            logoItemId,
            chromeTitle: brandTitle || DEFAULT_TITLE,
            orgHomeTo,
            orgBackLabel,
            hubHomeTo: orgHomeTo || '/projects',
            /** Site top-bar home: org landing when branded, else site root */
            chromeHomeTo: orgHomeTo || '/',
            /** Global projects hub (My projects) — escape from org chrome */
            projectsRootTo: '/projects',
            hubBackLabel: orgBackLabel || '← Projects',
            hubBackLabelLong: isOrgWorkspace
                ? `← Back to ${brandTitle || organizationName}`
                : '← Back to Projects',
            /** Breadcrumb / short root label (no arrow) */
            hubRootLabel: isOrgWorkspace
                ? (brandTitle || organizationName)
                : 'Projects',
        };
    }, [resolvedBranding]);
}

export { DEFAULT_TITLE as ORG_WORKSPACE_DEFAULT_TITLE };
